<!-- components/ProfileCard.vue -->
<template>
    <section class="flex justify-center items-center">
        <div class="relative max-h-[240px] max-w-[380px]">
            <!-- Background stacked cards -->
            <div
                class="absolute -top-16 left-10 w-full h-full rounded-2xl border border-[var(--background-btn)] bg-[var(--background-primary)] p-4">
                <div class="w-12 h-12 rounded-full overflow-hidden border border-[var(--background-btn)]">
                    <NuxtImg src="/images/join-waitlist/shop.png" width="46" height="46" alt="StyleHub Crafts" loading="lazy" />
                </div>
            </div>
            <div
                class="absolute -top-8 left-5 w-full h-full rounded-2xl border border-[var(--background-btn)] bg-[var(--background-primary)] p-4">
                <div class="w-12 h-12 rounded-full overflow-hidden border border-[var(--background-btn)]">
                    <NuxtImg src="/images/join-waitlist/shop.png" width="46" height="46" alt="StyleHub Crafts" loading="lazy" />
                </div>
            </div>

            <!-- Main Card -->
            <div
                class="relative w-full h-full rounded-2xl border border-[var(--background-btn)] bg-[var(--background-primary)] p-4 shadow-md">
                <!-- Top row: avatar + company name -->
                <div class="flex items-center gap-3 mb-4">
                    <div class="w-12 h-12 rounded-full overflow-hidden border border-[var(--background-btn)]">
                        <NuxtImg src="/images/join-waitlist/shop.png" width="46" height="46" alt="StyleHub Crafts" loading="lazy" />
                    </div>
                    <h2 class="text-lg font-semibold text-foreground">StyleHub Crafts</h2>
                </div>

                <!-- Bottom grid: 2x2 info boxes -->
                <div class="grid grid-cols-2 gap-3">
                    <!-- Product Count -->
                    <div class="space-y-0.5 p-1.5 bg-[#FAFAFA0A] rounded-md">
                        <p class="text-xs text-muted-foreground">Product Count</p>
                        <p class="text-base font-semibold text-foreground">5,000+</p>
                    </div>

                    <!-- Rating -->
                    <div class="space-y-0.5 bg-[#FAFAFA0A] rounded-md p-1.5">
                        <p class="text-xs text-muted-foreground">Rating</p>
                        <p class="text-base font-semibold text-foreground">4.8</p>
                        <Rating v-model="rating" :readonly="true" :cancel="false" class="text-sm" />
                    </div>

                    <!-- Key Offer -->
                    <div class="space-y-0.5 bg-[#FAFAFA0A] rounded-md p-1.5">
                        <p class="text-xs text-muted-foreground">Key Offer</p>
                        <p class="text-xs font-medium text-foreground">
                            Seasonal Discounts up to 50%
                        </p>
                    </div>

                    <!-- Location -->
                    <div class="space-y-0.5 bg-[#FAFAFA0A] rounded-md p-1.5">
                        <p class="text-xs text-muted-foreground">Location</p>
                        <p class="text-xs font-medium text-foreground">
                            Los Angeles, CA
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script setup lang="ts">
const rating = ref(5);
</script>
